<h1 *ngIf="message">Invitation Error</h1>
<p *ngIf="message === 'expired'">
  Invitation has been used or has expired. Please contact
  <a href="mailto:threatstatus@doc.govt.nz?subject=My invitation expired">
    threatstatus@doc.govt.nz
  </a> to request a new one.
</p>
<p *ngElseIf="message">{{message}}</p>